import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

export interface MaintenanceEstablishmentChoiceManualEntryReplaceActualProposalPayload {
  establishment_id: string
}

interface UseMaintenanceEstablishmentChoiceManualEntryReplaceActualProposalProps {
  manualEntryId: string
  options?: Partial<
    Omit<
      UseMutationOptions<unknown, ErrorResponse, MaintenanceEstablishmentChoiceManualEntryReplaceActualProposalPayload>,
      'mutationKey' | 'mutationFn'
    >
  >
}

export const useMaintenanceEstablishmentChoiceManualEntryReplaceActualProposal = ({
  manualEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceManualEntryReplaceActualProposalProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceManualEntryReplaceActualProposal'],
    mutationFn: (payload: MaintenanceEstablishmentChoiceManualEntryReplaceActualProposalPayload) => {
      return privateAxios.put(
        `/maintenance/establishment_choice/manual_entries/${manualEntryId}/replace_actual_proposal`,
        payload,
      )
    },
    ...options,
  })
}
